/* eslint-disable react/jsx-indent */
import { SrOnly } from '@tvg/fuse-utils';
import PropTypes from 'prop-types';
import React from 'react';
import { Ellipses } from './ellipses';
import ButtonStyled from './styled-button';
import { ListStyled } from './styled-pagination';
import { ELLIPSES } from './utils';

const { useCallback, useState } = React;

const ELLIPSES_ICON = 'PendingSimple';
const ENTER_KEY_CODE = 13;
const SPACE_KEY_CODE = 32;

const propTypes = {
	text: PropTypes.string.isRequired,
	currentPage: PropTypes.number.isRequired,
	callback: PropTypes.func,
	seoHref: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.bool
	]),
};

const defaultProps = {
	callback: undefined,
	seoHref: false
};

function PaginationButton({ text, currentPage, callback, seoHref }) {
	const ellipsesIcon = text?.startsWith(ELLIPSES) ? ELLIPSES_ICON : undefined;
	const isDisabled = text === String(currentPage) || ellipsesIcon;
	const [isFocused, setIsFocused] = useState(false);
	const href = seoHref && typeof seoHref === 'string' && !isDisabled ? seoHref : undefined;

	const onClickHandler = useCallback(
		(event) => {
			if(seoHref) event.preventDefault();
			if (callback) {
				const num = Number(text);
				const page = num > 0 ? num : 0;
				callback(event, page);
			}
		},
		[callback, text],
	);

	const onKeyDownHandler = useCallback((event) => {
		if (event?.keyCode === ENTER_KEY_CODE || event?.keyCode === SPACE_KEY_CODE) {
			setIsFocused(true);
		}
	}, []);

	const onBlurHandler = useCallback(() => {
		setIsFocused(false);
	}, []);

	const ariaProps = isDisabled ? { 'aria-current': 'page' } : {};

	if (ellipsesIcon) {
		return <Ellipses />;
	}

	return (
		<ListStyled>
			<ButtonStyled
				onClick={onClickHandler}
				fullWidth={false}
				variant="tertiary"
				disabled={!isFocused && isDisabled}
				className={isFocused && isDisabled && 'active-page'}
				onKeyDown={onKeyDownHandler}
				onBlur={onBlurHandler}
				href={href}
				{...ariaProps}
			>
				<SrOnly>Page</SrOnly> {text}
			</ButtonStyled> 
		</ListStyled>
	);
}

PaginationButton.propTypes = propTypes;
PaginationButton.defaultProps = defaultProps;
PaginationButton.displayName = 'PaginationButton';

export default PaginationButton;
